<template>
  <v-card outlined>
    <v-card-subtitle class="d-flex align-center justify-space-between grey lighten-4 mb-2 pa-3">
      <span>Select Options</span>
      <toggle-input
        :disabled="isLoading"
        :readonly="readonly"
        :value="field.dynamic"
        label="Dynamic Data"
        @input="onInput($event, 'dynamic')"
      />
    </v-card-subtitle>
    <v-card-text>
      <select-list
        v-if="field.dynamic"
        :value="field.dynamicKey"
        :items="moduleDynamicOptions"
        :readonly="readonly"
        class="mt-4"
        label="Dynamic Data"
        hide-details
        @input="onInput($event, 'dynamicKey')"
      />
      <template v-else>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Option Text</th>
              <th class="text-left">Option Value</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="field.options && field.options.length">
              <tr v-for="(option, index) in field.options || []" :key="index">
                <td>
                  <text-input
                    :disabled="isLoading"
                    :readonly="readonly"
                    :value="option.text"
                    background-color="white"
                    hide-details
                    required
                    @input="onSelectOptionInput($event, index, 'text')"
                  />
                </td>
                <td>
                  <text-input
                    :disabled="isLoading"
                    :readonly="readonly"
                    :value="option.value"
                    background-color="white"
                    hide-details
                    required
                    @input="onSelectOptionInput($event, index, 'value')"
                  />
                </td>
                <td class="text-right">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-btn
                        :disabled="isLoading || readonly"
                        class="my-3"
                        color="error"
                        icon
                        @click="onRemoveSelectOption(index)"
                        v-on="on"
                      >
                        <v-icon>delete_outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Option</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <tr v-else class="grey--text">
              <td>
                No options added...
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-btn
          :disabled="isLoading || readonly"
          class="mt-4"
          color="primary"
          depressed
          small
          @click="onAddSelectOption"
        >
          <v-icon left>add</v-icon>
          <span>Add Option</span>
        </v-btn>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'
// Components
import SelectList from '@/components/forms/select-list'
import TextInput from '@/components/forms/text-input'
import ToggleInput from '@/components/forms/toggle-input'

export default {
  name: 'SelectOptionConfig',
  components: { SelectList, TextInput, ToggleInput },
  props: {
    field: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({ getItemsForOption: 'options/getItemsForOption' }),
    moduleDynamicOptions() {
      return this.getItemsForOption('moduleDynamicOptions')
    },
  },
  methods: {
    onAddSelectOption() {
      const blankOption = () => ({ text: '', value: '' })
      this.$emit('input', [...this.field.options, blankOption()], 'options')
    },
    onInput(value, model) {
      this.$emit('input', value, model)
    },
    onRemoveSelectOption(index) {
      const options = this.field.options.slice(0, index).concat(this.field.options.slice(index + 1))
      this.$emit('input', options, 'options')
    },
    onSelectOptionInput(value, index, model) {
      const option = { ...this.field.options[index], [model]: value }
      const options = this.field.options
        .slice(0, index)
        .concat(option)
        .concat(this.field.options.slice(index + 1))
      this.$emit('input', options, 'options')
    },
  },
}
</script>
